import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const AREAS = [
  { label: "Grand Canal Dock", to: "/areas/airbnb-management-grand-canal-dock" },
  { label: "Ballsbridge", to: "/areas/airbnb-management-ballsbridge" },
  { label: "Swords", to: "/areas/airbnb-management-swords" },
  { label: "IFSC" },
  { label: "Dublin 2" },
  { label: "Ranelagh" },
  { label: "Dún Laoghaire" },
];

export default function Footer() {
  return (
    <footer className="bg-forest-900 text-cream noise-dark" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20 relative z-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img
              src="/logo-landscape.webp"
              alt="FieldGreen Property Management"
              className="h-16 w-auto rounded-lg"
              data-testid="footer-logo"
            />
            <p className="mt-4 font-serif text-lg italic text-sage">We manage the property. You collect the returns.</p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/60">
              End-to-end short-term rental and corporate stay management for Dublin property owners. Pricing, bookings,
              guests, cleaning and maintenance — handled.
            </p>
            <div className="mt-8 space-y-2 text-sm text-cream/70">
              <p data-testid="footer-email">stay@fieldgreenproperty.com</p>
              <p data-testid="footer-phone">+353 85 736 2033 — Andrew</p>
              <p>Dublin, Ireland</p>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow text-sage">Explore</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["Home", "/", "home"],
                ["How It Works", "/how-it-works", "how-it-works"],
                ["Services", "/services", "services"],
                ["Corporate Stays", "/corporate-stays", "corporate-stays"],
                ["About FieldGreen", "/about", "about"],
                ["FAQs", "/faqs", "faqs"],
                ["Stay With Us", "/stay", "stay"],
                ["Property Assessment", "/assessment", "assessment"],
              ].map(([label, to, id]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-${id}-link`} className="link-underline text-cream/70 hover:text-cream transition-colors duration-300">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="eyebrow text-sage">Areas we cover</p>
            <div className="mt-5 flex flex-wrap gap-2">
              {AREAS.map((a) =>
                a.to ? (
                  <Link
                    key={a.label}
                    to={a.to}
                    data-testid={`footer-area-${a.to.split("-").pop()}`}
                    className="rounded-full border border-sage/30 bg-sage/10 px-3.5 py-1.5 text-xs text-cream/80 transition-colors duration-300 hover:border-sage hover:text-cream"
                  >
                    {a.label}
                  </Link>
                ) : (
                  <span key={a.label} className="rounded-full border border-white/10 px-3.5 py-1.5 text-xs text-cream/60">
                    {a.label}
                  </span>
                )
              )}
            </div>
            <Link
              to="/assessment"
              data-testid="footer-cta-link"
              className="group mt-9 inline-flex items-center gap-2 rounded-full bg-cream px-5 py-2.5 text-sm font-semibold text-forest transition-colors duration-300 hover:bg-sage"
            >
              See What Your Property Could Earn
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-8 text-xs text-cream/40">
          <p>© {new Date().getFullYear()} FieldGreen Property Management. Dublin, Ireland.</p>
          <div className="flex items-center gap-6">
            <p>Short-term letting eligibility remains the owner's responsibility.</p>
            <Link to="/admin/leads" data-testid="footer-admin-link" className="hover:text-cream/70 transition-colors duration-300">
              Owner Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
